// Mock data for development - replace with real API calls later

/**
 * Mock data for bank synchronization
 */
const mockSyncData = [
  {
    id: 1,
    installment_number: "001/2024",
    client_name: "João Silva Santos",
    enterprise_name: "Residencial Vila Nova",
    block: "A",
    land: "15",
    due_date: "2024-01-15",
    original_value: 1500.00,
    updated_value: 1650.00,
    payment_status: "Pago",
    payment_date: "2024-01-14",
    sync_status: "Atualizado",
    sync_date: new Date().toISOString(),
  },
  {
    id: 2,
    installment_number: "002/2024",
    client_name: "Maria Oliveira Costa",
    enterprise_name: "Residencial Vila Nova",
    block: "B",
    land: "22",
    due_date: "2024-02-15",
    original_value: 1500.00,
    updated_value: 1500.00,
    payment_status: "Em Aberto",
    payment_date: null,
    sync_status: "Sincronizado",
    sync_date: new Date().toISOString(),
  },
  {
    id: 3,
    installment_number: "003/2024",
    client_name: "Carlos Roberto Lima",
    enterprise_name: "Residencial Vila Nova",
    block: "C",
    land: "08",
    due_date: "2024-03-15",
    original_value: 1800.00,
    updated_value: 1950.00,
    payment_status: "Pago",
    payment_date: "2024-03-10",
    sync_status: "Atualizado",
    sync_date: new Date().toISOString(),
  },
  {
    id: 4,
    installment_number: "004/2024",
    client_name: "Ana Paula Ferreira",
    enterprise_name: "Residencial Vila Nova",
    block: "A",
    land: "03",
    due_date: "2024-04-15",
    original_value: 1200.00,
    updated_value: 1200.00,
    payment_status: "Em Aberto",
    payment_date: null,
    sync_status: "Sincronizado",
    sync_date: new Date().toISOString(),
  },
  {
    id: 5,
    installment_number: "005/2024",
    client_name: "Roberto Carlos Silva",
    enterprise_name: "Residencial Vila Nova",
    block: "B",
    land: "17",
    due_date: "2024-05-15",
    original_value: 1600.00,
    updated_value: 1750.00,
    payment_status: "Pago",
    payment_date: "2024-05-12",
    sync_status: "Atualizado",
    sync_date: new Date().toISOString(),
  }
];

/**
 * Mock history data
 */
const mockHistoryData = [
  {
    id: 1,
    account_id: 1,
    sync_date: "2024-07-28T10:30:00Z",
    total_processed: 25,
    successful: 23,
    failed: 2,
    status: "Concluído",
  },
  {
    id: 2,
    account_id: 1,
    sync_date: "2024-07-27T14:15:00Z",
    total_processed: 30,
    successful: 30,
    failed: 0,
    status: "Concluído",
  }
];

/**
 * Simulates API delay
 * @param {number} ms - Milliseconds to wait
 */
const delay = (ms = 2000) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Sincroniza parcelas com o banco especificado (MOCK)
 * @param {number} accountId - ID da conta bancária
 * @returns {Promise} - Dados das parcelas sincronizadas
 */
export const syncBankInstallments = async (accountId) => {
  try {
    console.log(`🔄 Simulando sincronização para conta ${accountId}...`);
    
    // Simulate API delay
    await delay(2500);
    
    // Randomly simulate some variations in the data
    const randomizedData = mockSyncData.map(item => ({
      ...item,
      sync_date: new Date().toISOString(),
      // Randomly change some statuses for variety
      sync_status: Math.random() > 0.7 ? "Atualizado" : item.sync_status,
    }));
    
    console.log(`✅ Sincronização simulada concluída: ${randomizedData.length} parcelas`);
    return randomizedData;
    
  } catch (error) {
    console.error("Erro ao sincronizar parcelas:", error);
    throw new Error("Falha na sincronização bancária");
  }
};

/**
 * Busca histórico de sincronizações (MOCK)
 * @param {Object} filters - Filtros de busca
 * @param {number} filters.account_id - ID da conta bancária
 * @param {string} filters.start_date - Data inicial
 * @param {string} filters.end_date - Data final
 * @returns {Promise} - Histórico de sincronizações
 */
export const getSyncHistory = async (filters) => {
  try {
    console.log("🔍 Buscando histórico de sincronizações...", filters);
    
    // Simulate API delay
    await delay(1000);
    
    // Filter mock data based on account_id if provided
    let filteredHistory = mockHistoryData;
    if (filters.account_id) {
      filteredHistory = mockHistoryData.filter(item => item.account_id === filters.account_id);
    }
    
    console.log(`✅ Histórico encontrado: ${filteredHistory.length} registros`);
    return filteredHistory;
    
  } catch (error) {
    console.error("Erro ao buscar histórico de sincronizações:", error);
    throw new Error("Falha ao buscar histórico");
  }
};

/**
 * Busca status da última sincronização (MOCK)
 * @param {number} accountId - ID da conta bancária
 * @returns {Promise} - Status da última sincronização
 */
export const getLastSyncStatus = async (accountId) => {
  try {
    console.log(`🔍 Buscando status da última sincronização para conta ${accountId}...`);
    
    // Simulate API delay
    await delay(800);
    
    // Get the most recent sync for this account
    const lastSync = mockHistoryData
      .filter(item => item.account_id === accountId)
      .sort((a, b) => new Date(b.sync_date) - new Date(a.sync_date))[0];
    
    const status = {
      account_id: accountId,
      last_sync_date: lastSync?.sync_date || null,
      status: lastSync?.status || "Nunca sincronizado",
      total_processed: lastSync?.total_processed || 0,
      successful: lastSync?.successful || 0,
      failed: lastSync?.failed || 0,
      next_sync_available: true,
    };
    
    console.log("✅ Status da última sincronização:", status);
    return status;
    
  } catch (error) {
    console.error("Erro ao buscar status da sincronização:", error);
    throw new Error("Falha ao buscar status");
  }
};
